import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
} from '@mui/material';
import { Check, Close } from '@mui/icons-material';
import { Labeled } from 'react-admin';

const QuestionWiseShow = ({ result }: any) => {
    const questionWise = result?.questionWise || [];

    const formatTime = (seconds: number) => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return [hrs, mins, secs].map(val => String(val).padStart(2, '0')).join(':');
    };

    const displayDuration = (seconds: number) => {
        return formatTime(seconds);
    };

    return (
        <div style={{ width: '100%' }}>
            <div className="table py-10 w-full">
                <Labeled style={{ width: '100%' }} label={'Question Wise Responses'}>
                    <TableContainer style={{ width: '100%' }} component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Question #</TableCell>
                                    <TableCell>Is Correct</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Marks Obtained</TableCell>
                                    <TableCell>Time Spent</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {questionWise.map((row: any, index: number) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                '&:last-child td, &:last-child th': { border: 0 },
                                            }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {index + 1}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.isCorrect ? (
                                                    <Check sx={{ color: 'green' }} />
                                                ) : row.attempted ? (
                                                    <Close sx={{ color: 'red' }} />
                                                ) : (
                                                    <span>-</span>
                                                )}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.attempted ? 'ATTEMPTED' : 'NOT ATTEMPTED'}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {row.marksObtained}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {displayDuration(row.timeSpentInSeconds || 0)}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Labeled>
            </div>
        </div>
    );
};

export default QuestionWiseShow;
